import ICTSupplyOffers from "./ICTSupplyOffers";

const ICTSupply = () => {
  return (
    <section className="solution-item-page">
      <ICTSupplyOffers />
    </section>
  );
};

export default ICTSupply;
